@if (outlet === 'button') {
<button class="confirm-button" mat-flat-button [disabled]="disabled" [color]="color" (click)="openDialog()">
  <ng-container *ngTemplateOutlet="buttonText"></ng-container>
</button>
} @else if (outlet === 'link') {
<button class="confirm-button confirm-button--link" mat-button [disabled]="disabled" (click)="openDialog()">
  <ng-container *ngTemplateOutlet="buttonText"></ng-container>
</button>
}

<ng-template #buttonText>
  <span class="confirm-button__text"
    >@if (icon) {
    <mat-icon>{{ icon }}</mat-icon>
    } @if (!!textTemplate) {
    <ng-container *ngTemplateOutlet="textTemplate"></ng-container>
    } @else {
    {{ text }}
    }
  </span>
</ng-template>

<ng-template #confirmTitle>
  @if (!!dialogTitleTemplate) {
  <ng-container *ngTemplateOutlet="dialogTitleTemplate"></ng-container>
  } @else {
  {{ dialogTitle }}
  }
</ng-template>

<ng-template #confirmText>
  @if (!!dialogTextTemplate) {
  <ng-container *ngTemplateOutlet="dialogTextTemplate"></ng-container>
  } @else {
  {{ dialogText }}
  }

  <section class="actions">
    <button mat-flat-button color="primary" (click)="onConfirm()">{{ confirmTrue }}</button>
    <button mat-flat-button color="secondary" (click)="onDecline()">{{ confirmFalse }}</button>
  </section>
</ng-template>
